import { LockIcon } from 'lucide-react';

import { Header } from '../../../../../components/atoms/header/header';
import { Illustration, IllustrationName } from '../../../../../components/atoms/illustration/illustration';
import { Text } from '../../../../../components/atoms/text/text';
import { Card } from '../../../../../shadcn/components/ui/card';
import { cn } from '../../../../../shadcn/lib/utils';

type ContentCardState = 'active' | 'highlighted' | 'locked' | 'disabled';

type TocCardState = 'to-do' | 'in-progress' | 'done';

type TocCardProps = {
  readonly index: number;
  readonly title: string;
  readonly description?: string;
  readonly state: TocCardState;
  readonly onClick?: () => void;
};

const ImageBank: IllustrationName[][] = [
  ['Woman1', 'Woman1Locked'],
  ['Man1', 'Man1Locked'],
  ['Man2', 'Man2Locked'],
  ['Woman2', 'Woman2Locked'],
  ['Man3', 'Man3Locked'],
  ['Woman3', 'Woman3Locked'],
];

const mapState: Record<TocCardState, ContentCardState> = {
  'to-do': 'locked',
  'in-progress': 'highlighted',
  done: 'active',
};

const TocCard = ({ state: tocCardState, title, index, description, onClick }: TocCardProps) => {
  const imageIndex = index % ImageBank.length;
  const image = ImageBank[imageIndex][tocCardState === 'to-do' ? 1 : 0];
  const contentCardState = mapState[tocCardState];

  return (
    <Card className="p-0 overflow-hidden w-full h-auto">
      <button
        className={cn('relative w-full min-h-[96px] min-w-[300px] flex', {
          'bg-paper-mid': contentCardState === 'locked',
          'bg-neutral-100': contentCardState === 'disabled',
          'cursor-pointer': contentCardState !== 'locked',
        })}
        disabled={contentCardState === 'locked' || contentCardState === 'disabled'}
        onClick={onClick}
      >
        <div className="absolute top-0 left-0 right-0 bottom-0 object-cover inline-flex justify-end w-full">
          <Illustration name={image} />
        </div>
        <div className="p-4 flex flex-col justify-end items-start max-w-3/4 z-1">
          {contentCardState === 'locked' && <LockIcon className="text-teal-light mb-1" size={16} />}
          <Header
            className={cn(
              'text-left break-words hyphens-auto',
              contentCardState === 'highlighted' ? '!text-teal-mid' : '!text-teal-light',
              {
                '!text-neutral-600': contentCardState === 'disabled',
              }
            )}
            level="h3"
          >
            {title}
          </Header>
          {description && (
            <Text
              className={cn('!text-teal-light text-left', {
                '!text-neutral-600': contentCardState === 'disabled',
              })}
            >
              {description}
            </Text>
          )}
        </div>
      </button>
    </Card>
  );
};

export { TocCard };
export type { TocCardState };
